
import React, { useEffect } from "react";
import "./beliefs.css";
import EditableText from "../../components/editable/EditableText";
import EditableBeliefField from "../../components/editable/EditableBeliefField";
import EditableBeliefsValues from "../../components/editable/EditableBeliefsValues";
import { useContent } from "../../context/ContentContext";
import { resolveCoreBeliefs } from "../../data/coreBeliefs";

const BELIEF_ICONS = [
    "fa-solid fa-users",
    "fa-solid fa-book",
    "fa-solid fa-heart",
    "fa-solid fa-water",
    "fa-solid fa-dove",
    "fa-solid fa-seedling",
    "fa-solid fa-cloud-sun",
    "fa-solid fa-globe",
];

const Beliefs = () => {
    const { getContent } = useContent();
    const beliefs = resolveCoreBeliefs(getContent);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    useEffect(() => {
        const observerOptions = {
            root: null,
            threshold: 0.1,
        };

        const observerCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        const elements = document.querySelectorAll(".fade-up, .zoom-in");
        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }, []);

    return (
        <>
            <div className="beliefs-background fade-up">
                <h1 className="beliefs-title-text">
                    <EditableText contentKey="beliefs.hero.title" tag="span">
                        OUR BELIEFS & VALUES
                    </EditableText>
                </h1>
            </div>
            <section className="beliefs-description-section fade-up">
                <EditableText contentKey="beliefs.intro" tag="p" className="beliefs-description" multiline>
                    Discover a place where love brings healing, hope inspires change, and
                    faith leads to a brighter tomorrow. Come as you are, and find belonging in a
                    community that cares.
                </EditableText>
            </section>
            <section className="beliefs-container fade-up">
                <EditableText contentKey="beliefs.section_title" tag="h2" className="beliefs-title">
                    What We Believe
                </EditableText>
                <div
                    className="beliefs-row"
                    data-content-key="beliefs.items"
                    data-belief-count={beliefs.length}
                >
                    {beliefs.map((belief, index) => (
                        <div className="belief zoom-in" key={index}>
                            <i className={BELIEF_ICONS[index] || BELIEF_ICONS[0]}></i>
                            <EditableBeliefField index={index} field="title" tag="h2" />
                            <EditableBeliefField index={index} field="description" tag="p" multiline />
                            <blockquote>
                                <EditableBeliefField index={index} field="verse_text" tag="p" multiline />
                                <footer>– <EditableBeliefField index={index} field="verse_ref" tag="span" /></footer>
                            </blockquote>
                        </div>
                    ))}
                </div>
            </section>
            <EditableBeliefsValues />
        </>
    );
};

export default Beliefs;
